/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ParcelLpisIntersect } from './parcelLpisIntersect.model';
import { ParcelOwnershipJuristicTypeEntity } from './parcelOwnershipJuristicTypeEntity.model';
import { ParcelGroup } from './parcelGroup.model';


/**
 * DTO pro seznam parcel budovy - obsahuje data parcely, zastavěnou plochu a osvobození
 */
export interface ParcelBuildingListDto { 
    /**
     * ID budovy na parcele
     */
    budId?: number;
    /**
     * Název druhu číslování
     */
    cislNazev?: string;
    /**
     * ID prvního právního důvodu nároku na osvobození z číselníku DNE - Právní důvody osvobození
     */
    dnepduos1Id?: number | null;
    /**
     * Poslední rok osvobození dle prvního právního důvodu - rok, do něhož osvobození trvá (včetně)
     */
    dnepduos1Year?: number | null;
    /**
     * ID druhého právního důvodu nároku na osvobození z číselníku DNE - Právní důvody osvobození
     */
    dnepduos2Id?: number | null;
    /**
     * Poslední rok osvobození dle druhého právního důvodu - rok, do něhož osvobození trvá (včetně)
     */
    dnepduos2Year?: number | null;
    /**
     * ID třetího právního důvodu nároku na osvobození z číselníku DNE - Právní důvody osvobození
     */
    dnepduos3Id?: number | null;
    /**
     * Poslední rok osvobození dle třetího právního důvodu - rok, do něhož osvobození trvá (včetně)
     */
    dnepduos3Year?: number | null;
    /**
     * Název druhu pozemku
     */
    drupozNazev?: string;
    /**
     * Datum konce platnosti verze parcely
     */
    endDate?: string;
    /**
     * ID parcely (primární klíč)
     */
    id?: number;
    /**
     * Název katastrálního území
     */
    katuzeNazev?: string;
    /**
     * Název kraje
     */
    krajNazev?: string;
    /**
     * Číslo listu vlastnictví
     */
    lv?: number;
    /**
     * Název obce
     */
    obecNazev?: string;
    /**
     * Název okresu
     */
    okresNazev?: string;
    /**
     * ID parcely z katastru nemovitostí
     */
    parId?: number;
    /**
     * Typ parcely (PZE nebo PKN)
     */
    parType?: string;
    /**
     * Skupiny parcel, do kterých parcela patří
     */
    parcelGroups?: Array<ParcelGroup>;
    /**
     * Průnik parcely s LPIS bloky
     */
    parcelLpisIntersect?: ParcelLpisIntersect;
    /**
     * Typy vlastnictví parcely
     */
    parcelOwnershipJuristicTypes?: Array<ParcelOwnershipJuristicTypeEntity>;
    /**
     * Parcelní číslo
     */
    parcis?: string;
    /**
     * Díl parcelního čísla
     */
    parcisDil?: number;
    /**
     * Datum počátku platnosti verze parcely
     */
    startDate?: string;
    /**
     * Výměra parcely v m²
     */
    vymera?: number;
    /**
     * Zastavěná výměra parcely v m²
     */
    zastavenaVymera?: number;
    /**
     * Název způsobu využití pozemku
     */
    zpvypoNazev?: string;
}

